export const grabFrame = (file, { at = 0.1, width = 640, timeout = 8000 } = {}) =>
  new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const video = document.createElement("video");
    let done = false;
    const finish = (blob) => {
      if (done) return;
      done = true;
      clearTimeout(timer);
      URL.revokeObjectURL(url);
      video.remove();
      resolve(blob ? new File([blob], file.name.replace(/\.[^.]+$/, "") + "-thumb.jpg", { type: "image/jpeg" }) : null);
    };
    const timer = setTimeout(() => finish(null), timeout);
    video.muted = true;
    video.playsInline = true;
    video.preload = "auto";
    video.crossOrigin = "anonymous";
    video.onerror = () => finish(null);
    video.onloadedmetadata = () => {
      const d = video.duration;
      video.currentTime = Number.isFinite(d) && d > 0 ? Math.min(Math.max(1, d * at), d - 0.1) : 1;
    };
    video.onseeked = () => {
      try {
        const scale = width / (video.videoWidth || width);
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = Math.round((video.videoHeight || width * 0.5625) * scale);
        canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((b) => finish(b), "image/jpeg", 0.82);
      } catch {
        finish(null);
      }
    };
    video.src = url;
  });
